import { createAsyncThunk } from '@reduxjs/toolkit';
import { PORTAL_TYPES } from '../../app/constants/roles';
import httpService from './httpService';

export const getPortalRoles: any = createAsyncThunk<any>(
	'getPortalRoles',
	async (portalType, { rejectWithValue }: any) => {
		try {
			const response = await httpService.get(`role/`, {
				params: {
					portalType: portalType
				}
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const getPortalModules: any = createAsyncThunk<any>(
	'getPortalModules',
	async (dispatch, { rejectWithValue }: any) => {
		try {
			const response = await httpService.get(`role/modules`, {
				params: {
					portalType: PORTAL_TYPES.SYSTEM_PORTAL
				}
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const addRole: any = createAsyncThunk<any>(
	'addRole',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response: any = await httpService.post(`role/`, data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const editRole: any = createAsyncThunk<any>(
	'editRole',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response: any = await httpService.put(`role/`, data);
			return response;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const editRolePermissions: any = createAsyncThunk<any>(
	'editRolePermissions',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response: any = await httpService.put(
				`role/edit-role-permission`,
				data
			);
			return response;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);

export const deleteRole: any = createAsyncThunk<any>(
	'deleteRole',
	async (id: any, { rejectWithValue }: any) => {
		try {
			const response: any = await httpService.delete(`role`, {
				params: {
					roleId: id
				}
			});
			return response;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
